import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const MobileIcon: React.FC<IconProps> = ({ 
  width = 16, 
  height = 16, 
  className = "" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect 
        x="5" 
        y="1" 
        width="6" 
        height="14" 
        rx="1.5" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        fill="none"
      />
      <circle 
        cx="8" 
        cy="12.5" 
        r="0.5" 
        fill="currentColor"
      />
    </svg>
  );
};
